/**
 * Token-aligned chart palette — design system v4 "Slate and blue".
 *
 * Recharts needs real color strings (not Tailwind classes), so these mirror the
 * values in `index.css`. Use these everywhere instead of ad-hoc hex so every
 * chart in every hub looks the same.
 */
export const CHART = {
  blue: '#2563EB', // --primary
  green: '#16A34A', // --success
  amber: '#D97706', // --warning
  red: '#DC2626', // --destructive
  sky: '#0284C7', // --info
  purple: '#7C3AED',
  teal: '#0D9488',
  gray: '#94A3B8', // slate-400
} as const;

/** Default categorical series order (distinct hues, blue first). */
export const CHART_SERIES = [
  CHART.blue,
  CHART.sky,
  CHART.green,
  CHART.amber,
  CHART.purple,
  CHART.red,
  CHART.teal,
  CHART.gray,
] as const;

/**
 * Sequential blue ramp (dark → light) for charts where series are ranks of one
 * dimension (teams, categories) rather than different kinds of thing.
 */
export const CHART_SEQUENTIAL = [
  '#1E3A8A', '#1E40AF', '#1D4ED8', '#2563EB', '#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE',
] as const;

/** Ticket / task priority colors — the only place priority hues are defined. */
export const PRIORITY_COLORS = {
  critical: CHART.red,
  high: '#EA580C', // orange-600: between warning and destructive
  medium: CHART.amber,
  low: CHART.green,
} as const;

/** Axis lines / tick labels (slate-400). */
export const CHART_AXIS = '#94A3B8';
/** Cartesian grid lines (slate-200). */
export const CHART_GRID = '#E2E8F0';

/** Recharts <Tooltip contentStyle> — follows the theme via CSS variables. */
export const CHART_TOOLTIP = {
  backgroundColor: 'hsl(var(--popover))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '8px',
  fontSize: '12px',
  color: 'hsl(var(--popover-foreground))',
} as const;

export const CHART_TOOLTIP_ITEM = { color: 'hsl(var(--popover-foreground))', fontWeight: 500 } as const;
